import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPercent, faGlobe, faUsers } from '@fortawesome/free-solid-svg-icons';
import './styles.css';
import { useGlobalState } from '../../contexts/GlobalStateContext';
import styled from 'styled-components';

const StatsSection = styled.div`
  padding: 60px 0;
  background: #000;
  color: white;
  @media (max-width: 768px) {
    padding: 40px 0;
  }
`;

const StatsContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  text-align: center;
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 0 16px;
  }
`;

const StatItem = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.08);
  transition: all 0.3s ease-in-out;
  min-height: 100%;
  
  &:hover {
    transform: translateY(-6px);
    background: rgba(255, 255, 255, 0.14);
  }

  @media (max-width: 576px) {
    padding: 16px;
  }
`;

const StatNumber = styled.div`
  font-size: 48px;
  color: #fff;
  margin-bottom: 12px;
  @media (max-width: 576px) {
    font-size: 40px;
  }
`;

const StatLabel = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 10px;
  line-height: 1.3;
  @media (max-width: 576px) {
    font-size: 16px;
  }
`;

const StatDescription = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: #ccc;
  max-width: 320px;
  margin: 0 auto;
  @media (max-width: 576px) {
    font-size: 13px;
  }
`;

const AboutSection = () => {

  const { handleOpenLogin, handleOpenRegister } = useGlobalState();

/*   const handleOpenRegister = () => {
    const registerButton = document.querySelector('[data-modal="register"]');
    if (registerButton) {
      registerButton.click();
    }
  };

  const handleOpenLogin = () => {
    const loginButton = document.querySelector('[data-modal="login"]');
    if (loginButton) {
      loginButton.click();
    }
  }; */

  return (
    <div className="about-container">
      

      {/* Conteúdo Principal */}
      <section className="about-content">
        <div className="content-grid">
          <div className="content-item">
            <h2 className="section-title">Nossa missão</h2>
            <h3 className="section-subtitle">Rompendo Fronteiras, Expandindo Conexões</h3>
            <p className="section-text">JoviPlanet é uma plataforma internacional dedicada ao imobiliário. Nossa missão é oferecer, de forma simples e eficiente, acesso a propriedades de prestígio e de charme em destinos de renome pelo mundo. Seja para um imóvel de luxo ou uma casa de campo, conectamos você às melhores oportunidades, ampliando conexões sem fronteiras.
            </p>
          </div>

          <div className="content-item">
            <h2 className="section-title">O que nós fazemos</h2>
            <h3 className="section-subtitle">Tecnologia para o mundo imobiliário</h3>
            <p className="section-text">Na JoviPlanet, oferecemos uma experiência completa no setor imobiliário. Nossa plataforma internacional conecta compradores e vendedores e traz eficiência a todo o percurso de busca, venda, arrendamento e reservas para férias. Com tecnologia de ponta, tornamos a publicação e a descoberta de imóveis simples, rápida e prática — em qualquer lugar.
            </p>
          </div>

          <div className="content-item">
            <h2 className="section-title">Compromisso com a Segurança</h2>
            <h3 className="section-subtitle">Protegendo a sua privacidade</h3>
            <p className="section-text">Compreendemos a importância da privacidade e segurança dos nossos clientes. Na JoviPlanet, temos um verdadeiro compromisso em proteger os dados pessoais dos nossos visitantes e clientes registados. A sua confiança é fundamental para nós.
            </p>
          </div>

          <div className="content-item">
            <h2 className="section-title">Oportunidades globais</h2>
            <h3 className="section-subtitle">Conectando o mundo do mercado imobiliário</h3>
            <p className="section-text">Se já tem um site imobiliário nacional, pretende expandir o seu negócio para fora do seu país e aumentar as suas vendas é juntando-se a nós. Na JoviPlanet, oferecemos uma plataforma internacional que permite destacar as suas ofertas para qualquer tipo de público a nível mundial.
            </p>
          </div>

          <div className="content-item">
            <h2 className="section-title">Sem comissões, sem barreiras linguísticas</h2>
            <h3 className="section-subtitle">Maior Visibilidade Internacional</h3>
            <p className="section-text">Na JoviPlanet, acreditamos na transparência e na simplicidade. Não cobramos comissões sobre quaisquer transações entre proprietários e usuários. Além disso, todos os anúncios são traduzidos em vários idiomas, garantindo que o seu imóvel alcance todo o público em mais de 50 países.
            </p>
          </div>

          <div className="content-item">
            <h2 className="section-title">Junte-se a nós</h2>
            <h3 className="section-subtitle">Destaque Internacional para os seus imóveis</h3>
            <p className="section-text">Gostaria de dar destaque internacional ao seu imóvel? Cadastre-se agora e selecione a conta de cliente e o plano que melhor atende às suas necessidades. Na JoviPlanet, oferecemos visibilidade excepcional em escala global, proporcionando oportunidades interessantes para a sua propriedade. Junte-se a nós e explore um mundo de possibilidades no mercado imobiliário internacional!
            </p>
          </div>
        </div>
      </section>

      <StatsSection>
        <StatsContainer>
          <StatItem>
            <StatNumber>
              <FontAwesomeIcon icon={faPercent} />
            </StatNumber>
            <StatLabel>Comissão zero na venda</StatLabel>
            <StatDescription>
              Você só paga para colocar o anúncio online, uma única vez, após validação do virtual.
            </StatDescription>
          </StatItem>

          <StatItem>
            <StatNumber>
              <FontAwesomeIcon icon={faGlobe} />
            </StatNumber>
            <StatLabel>Visibilidade nacional e internacional</StatLabel>
            <StatDescription>
              O seu anúncio é traduzido automaticamente para mais de 20 idiomas e divulgado internacionalmente, permitindo alcançar potenciais compradores em mais de 50 países.
            </StatDescription>
          </StatItem>

          <StatItem>
            <StatNumber>
              <FontAwesomeIcon icon={faUsers} />
            </StatNumber>
            <StatLabel>+ 1 milhão de visitas por mês</StatLabel>
            <StatDescription>
              Receba os dados de potenciais compradores diretamente por email.
            </StatDescription>
          </StatItem>
        </StatsContainer>
      </StatsSection>

      <div className="steps-section">
        <div className="steps-wrapper">
          <div className="steps-container">
            <div className="steps-content">
              <h3>Anuncie com facilidade:</h3>
              <h2>São só 4 passos para o sucesso!</h2>
              
              <div className="steps-grid">
                <div className="step-item">
                  <div className="step-number">1</div>
                  <div className="step-label">Criar conta</div>
                </div>

                <div className="step-item">
                  <div className="step-number">2</div>
                  <div className="step-label">Escolher Plano</div>
                </div>

                <div className="step-item">
                  <div className="step-number">3</div>
                  <div className="step-label">Introduzir Imóvel</div>
                </div>

                <div className="step-item">
                  <div className="step-number">4</div>
                  <div className="step-label">Publicar Imóvel</div>
                </div>
              </div>
            </div>

            <div className="steps-card">
              <h2>
                Junte-se a nós,<br />
                <strong>Explore um mundo de possibilidades</strong><br />
                No mercado imobiliário internacional!
              </h2>
              <div className="card-buttons">
                <button className="btn-registration" onClick={handleOpenRegister}>Criar conta</button>
                <button className="btn-login" onClick={handleOpenLogin}>Iniciar sessão</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;